import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { RoutesMe } from "./routes"
import { initAnalytics } from "./analytics/googleAnalytics";

// Before render, not inside an effect: this pushes the Consent Mode "everything
// denied" defaults onto dataLayer, and those must be in place before gtag.js is
// fetched or GA4 would set a cookie in the gap. Module scope also means it runs
// exactly once, unaffected by StrictMode's double-invoked effects.
initAnalytics();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode style={{ width: "100%" }}>
    <RoutesMe />
  </React.StrictMode>
);
